import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import ReactPixel from 'react-facebook-pixel';
import Navbar from './components/Navbar';
import Sidebar from './components/Sidebar';
import HeroSection from './components/HeroSection';
import ExperienceJourney from './components/ExperienceJourney';
import InstagramGallery from './components/InstagramGallery';
import AboutSection from './components/AboutSection';
import ContactPage from './components/ContactPage';
import TopProductsPage from './components/TopProductsPage';

// Initialize Pixel with your ID
const PIXEL_ID = '819025574295687';

const PixelTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Initialize Pixel
    ReactPixel.init(PIXEL_ID);
    ReactPixel.pageView();
  }, []);

  useEffect(() => {
    // Track page view on route change
    ReactPixel.pageView();
  }, [location]);

  return null;
};

// Home component for the main portfolio page
const HomePage: React.FC = () => {
  const [activeSection, setActiveSection] = useState('hero');

  const location = useLocation();

  // Scroll to section based on hash or state
  useEffect(() => {
    if (location.hash) {
      const sectionId = location.hash.replace('#', '');
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100); // Small delay to ensure DOM is ready
    }
  }, [location]);

  useEffect(() => {
    const handleScroll = () => {
      const sections = ['hero', 'vision', 'process', 'plan', 'expertise', 'consultation', 'portfolio', 'video', 'about'];
      const scrollPosition = window.scrollY + 100;

      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const { offsetTop, offsetHeight } = element;
          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
            setActiveSection(section);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="App">
      <Navbar />
      <HeroSection />
      <ExperienceJourney />
      <InstagramGallery />
      {/* <VideoSection /> */}
      <AboutSection />
    </div>
  );
};

function App() {
  return (
    <Router>
      <PixelTracker />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/recommendations/brides-top-products" element={<TopProductsPage />} />
      </Routes>
    </Router>
  );
}

export default App;
